// =============================================================================
// New-products carousel — Swiper, auto-width slides, free-scroll drag.
// =============================================================================
(function ($) {
    'use strict';

    $(function () {
        if (typeof Swiper === 'undefined') { return; }

        const $container = $('[data-new-products-swiper]');
        if (!$container.length) { return; }

        new Swiper($container[0], {
            slidesPerView: 'auto',
            spaceBetween: 20,
            freeMode: true,
            grabCursor: true,
            watchOverflow: true,
            speed: 450,
            a11y: {
                prevSlideMessage: 'Previous products',
                nextSlideMessage: 'Next products',
            },
            breakpoints: {
                0:    { spaceBetween: 12 },
                768:  { spaceBetween: 16 },
                1280: { spaceBetween: 20 },
            },
        });
    });
})(jQuery);
